/**
 * ルート逸脱判定。
 * GPS の一瞬のブレで再探索しないよう「しきい値超えが N 回連続」で逸脱とみなす。
 * しきい値は GPS 精度（accuracy）に応じて広げる。
 */
export class OffRouteDetector {
  private count = 0;

  constructor(
    private readonly opts = {
      /** 基本しきい値 [m] */
      baseThreshold: 35,
      /** 連続回数 */
      consecutive: 3,
    },
  ) {}

  /** ずれがしきい値を超えているか（1回だけで判定する。表示の切り替え用） */
  exceeds(offset: number, accuracy: number): boolean {
    return offset > Math.max(this.opts.baseThreshold, accuracy * 1.5);
  }

  /** @returns 逸脱と判定したら true（true を返したらカウンタはリセットされる） */
  update(offset: number, accuracy: number): boolean {
    this.count = this.exceeds(offset, accuracy) ? this.count + 1 : 0;
    if (this.count >= this.opts.consecutive) {
      this.count = 0;
      return true;
    }
    return false;
  }

  reset(): void {
    this.count = 0;
  }
}
